import { createContext, createElement, type PropsWithChildren, type ReactElement, useContext } from 'react';

const LoyaltyEnabledContext = createContext(true);

export function LoyaltyEnabledProvider({ enabled, children }: PropsWithChildren<{ enabled: boolean }>): ReactElement {
    return createElement(LoyaltyEnabledContext.Provider, { value: enabled }, children);
}

export function useLoyaltyEnabled(): boolean {
    return useContext(LoyaltyEnabledContext);
}
